import Header from "@/components/Header";
import ReviewCards from "@/components/Reviews/Cards";
import Pagination from "@/components/Pagination";
import { useReviews } from "@/hooks/use-review";
import SearchBar from "@/components/Reviews/SearchBar";
import { useState, useEffect } from "react";

export default function ReviewPage() {
  const {
    reviews,
    loading,
    error,
    currentPage,
    totalItems,
    setCurrentPage,
    itemsPerPage,
    featured,
    setFeatured,
    rating,
    setRating,
    order,
    applyFilter,
    setOrder,
    setItemsPerPage,
    searchTerm,
    setSearchTerm,
  } = useReviews();

  return (
    <div className="flex justify-center items-center w-full flex-col gap-6 relative">
      <Header name="My Reviews" />
      <SearchBar
        placeholder="Search by Consultation Id"
        rating={rating}
        setRating={setRating}
        featured={featured}
        setFeatured={setFeatured}
        applyFilter={applyFilter}
        order={order}
        setOrder={setOrder}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      // clearFilters={clearFilters}
      />
      <hr className="w-full px-2" />
      <ReviewCards reviews={reviews} isLoading={loading} error={error} />
      <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        onItemsPerPageChange={setItemsPerPage}
      />
      <div className="mb-[70px]" />
    </div>
  );
}
